module.exports = __webpack_public_path__ + "img/cbsyq.0398ed63.png";